<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-combobox
            v-model="selectedItems"
            :items="items"
            chips
            :label="label"
            multiple
            clearable
            persistent-hint
            item-text="title"
            item-value="value"
            hide-selected
            hide-details
            @input="changeItems"
            @change="changeItems"
    >
        <!--@input="changeGroups"-->
        <template v-slot:selection="{ index, item }">
            <v-chip
                    :key="index"
                    close
                    @click:close="removeItem(index)"
            >
                {{ item.title }}
            </v-chip>
        </template>
    </v-combobox>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'ModuleCombobox',
    props: ['label', 'itemsInModule', 'params', 'load', 'modelItems', 'methodId', 'index', 'indexCell'],
    data() {
        return {
            selectedItems: [],
            userIds: [
                { value: '{user_id}', title: 'Текущему пользователю' },
                { value: '{ref}', title: 'Тому кто пригласил' },
                { value: '{ref_ref}', title: 'Тому кто пригласил того кто пригласил' },
                { value: '{forward_from_user_id}', title: 'Тому от кого пересланное сообщение' },
                { value: '{result_ref}', title: 'Тому чей ID в реферальной ссылке' }
            ]
        }
    },
    methods: {
        loadItems() {
            this.selectedItems = []
            if (this.params.loadValues === 'mailing_group') {
                for (let i = 0; i < this.modelItems.length; i++) {
                    let item = this.getMailingGroupById(this.modelItems[i])
                    if (item !== undefined) {
                        this.selectedItems.push({ value: item.id, title: item.title })
                    }
                }
            }
            if (this.params.loadValues === 'messages') {
                for (let i = 0; i < this.modelItems.length; i++) {
                    let item = this.getMessageById(this.modelItems[i])
                    if (item !== undefined) {
                        this.selectedItems.push({ value: item.id, title: item.title })
                    }
                }
            }
            if (this.params.loadValues === 'variables') {
                for (let i = 0; i < this.modelItems.length; i++) {
                    let item = this.getVariableById(this.modelItems[i])
                    if (item !== undefined) {
                        this.selectedItems.push({ value: item.id, title: item.title })
                    }
                }
            }
            if (this.params.loadValues === 'secretClientVotes') {
                for (let i = 0; i < this.modelItems.length; i++) {
                    let item = this.getSecretClientVoteById(this.modelItems[i])
                    if (item !== undefined) {
                        this.selectedItems.push({ value: item.id, title: item.title })
                    }
                }
            }
            if (this.params.loadValues === 'userIds') {
                for (let i = 0; i < this.modelItems.length; i++) {
                    let item = this.userIds.find(userId => userId.value === this.modelItems[i])
                    if (item !== undefined) {
                        this.selectedItems.push(item)
                    } else {
                        this.selectedItems.push({ value: this.modelItems[i], title: this.modelItems[i] })
                    }
                }
            }
        },
        removeItem(index) {
            this.selectedItems.splice(index, 1)
            this.changeItems()
        },
        changeItems() {
            let items = []
            let loadValues = this.params.loadValues
            for (let i = 0; i < this.selectedItems.length; i++) {
                if (loadValues === 'userIds' && !this.selectedItems[i].hasOwnProperty('value')) {
                    this.selectedItems[i] = { value: this.selectedItems[i], title: this.selectedItems[i] }
                }
                items.push(this.selectedItems[i].value)
            }
            this.$emit('updateItems', { items: items, methodId: this.methodId, index: this.index, indexCell: this.indexCell })
        }
    },
    computed: {
        ...mapGetters({
            mailingGroups: 'clients/mailingGroups',
            secretClientVotes: 'secretClients/secretClientVotes',
            messages: 'messages/messages',
            variables: 'scenarios/variables',
            getMailingGroupById: 'clients/getMailingGroupById',
            getSecretClientVoteById: 'secretClients/getSecretClientVoteById',
            getMessageById: 'messages/getMessageById',
            getVariableById: 'scenarios/getVariableById',
            mailingGroupsLoaded: 'clients/mailingGroupsLoaded'
        }),
        items() {
            let items = []
            if (this.params.loadValues === 'mailing_group') {
                this.mailingGroups.forEach(function (item, i, array) {
                    items.push({ title: item.title, value: item.id })
                })
            }
            if (this.params.loadValues === 'messages') {
                this.messages.forEach(function (item, i, array) {
                    items.push({ title: item.title, value: item.id })
                })
            }
            if (this.params.loadValues === 'variables') {
                this.variables.forEach(function (item, i, array) {
                    items.push({ title: item.title, value: item.id })
                })
            }
            if (this.params.loadValues === 'secretClientVotes') {
                this.secretClientVotes.forEach(function (item, i, array) {
                    items.push({ title: item.title, value: item.id })
                })
            }
            if (this.params.loadValues === 'userIds') {
                items = this.userIds
            }
            return items
        }
    },
    watch: {
        load(value) {
            if (value) {
                this.loadItems()
            }
        },
        mailingGroupsLoaded() {
            this.loadItems()
        }
    },
    mounted() {
        this.loadItems() // первоначальная загрузка, потому что watch не срабатывает
    }
}
</script>

<style scoped>

</style>
